<template>
  <div class="h-screen w-full bg-white">
    <auth-logo-banner/>

    <div class="vx-row no-gutter w-full items-center justify-center pb-base bg-white">
      <div class="vx-col w-full sm:w-6/12 md:w-5/12 lg:w-4/12 xl:w-3/12 py-base">
        <vx-card no-shadow card-border>
          <div
            slot="no-body">
            <div class="vx-row no-gutter justify-center items-center p-8">
              <div class="vx-col w-full">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('$Auth.ResetPasswordTitle') }}</h4>
                  <p>{{ $t('$Auth.ResetPasswordMsg') }}</p>
                </div>

                <form @submit.prevent>
                  <password-input
                    v-model="password"
                    v-validate="'required|password'"
                    data-vv-validate-on="input"
                    class="w-full input-password-eye"
                    :danger="errors.has($t('$Auth.NewPassword'))"
                    :danger-text="errors.first($t('$Auth.NewPassword'))"
                    val-icon-danger="clear"
                    :label="$t('$Auth.NewPassword')"
                    :name="$t('$Auth.NewPassword')"
                    required/>

                  <div class="mt-8">
                    <vs-button
                      class="w-full"
                      @click.prevent="sendRequestToChange()">
                      {{ $t('$Auth.ResetPasswordTitle') }}
                    </vs-button>

                    <vs-button
                      type="border"
                      to="/login"
                      class="w-full mt-3">
                      {{ backToMsg }}
                    </vs-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AuthLogoBanner from '@/views/pages/auth/components/AuthLogoBanner.vue';
import PasswordInput from '@/components/PasswordInput.vue';

/**
 * Page to reset de password
 *
 * @module views/pages/auth/TheResetPassword
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {string} jwtTokenRecoverPassword - security jwt token to validate request
 * @vue-data {string} password - new password
 * @vue-event {void} changePassword - send the new password to save
 * @vue-event {void} sendEmailToRecover - make reset action and notify the user
 */
export default {
  name: 'TheResetPassword',
  components: {
    AuthLogoBanner,
    PasswordInput,
  },
  data() {
    return {
      jwtTokenRecoverPassword: this.$route.params.tokenRecoverPassword,
      password: '',
    };
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'auth/isUserLoggedIn',
    }),
    backToMsg() {
      return this.isUserLoggedIn ? this.$t('$Auth.BackToDashboard') : this.$t('$Auth.BackToLogin');
    },
  },
  methods: {
    ...mapActions({
      changePassword: 'auth/changePassword',
    }),
    async sendRequestToChange() {
      const formIsValid = await this.$validator.validate();

      if (!formIsValid) {
        document.getElementsByName([this.$validator.errors.items[0].field])[0].focus();
        return;
      }

      this.$vs.loading({ type: 'radius' });
      await this.changePassword(
        {
          jwtTokenRecoverPassword: this.jwtTokenRecoverPassword,
          password: this.password,
        },
      );
      this.$vs.loading.close();

      // Emit global event to clear forgot password rate limiting
      console.log('🎯 TheResetPassword: Password reset successful - clearing global state');
      window.dispatchEvent(new CustomEvent('passwordResetSuccess'));
      
      // Clear localStorage directly since components may be on different pages
      localStorage.removeItem('forgotPasswordLastSent');
      console.log('🎯 TheResetPassword: Cleared forgotPasswordLastSent from localStorage');

      this.$showSuccessActionNotification({
        title: this.$t('$Auth.ResetPasswordTitle'),
        text: this.$t('$Auth.ResetPasswordSuccess'),
      });

      await this.$router.push({ name: 'login' });
    },
  },
};
</script>
